module.exports = __webpack_public_path__ + "img/productHome2.8a0d00c6.png";